import { render, staticRenderFns } from "./StudentUploadQrcodeDocument.vue?vue&type=template&id=1f9f77e4&"
import script from "./StudentUploadQrcodeDocument.vue?vue&type=script&lang=ts&"
export * from "./StudentUploadQrcodeDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports